import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'reactstrap';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useReactToPrint } from 'react-to-print';
import { useLocation } from 'react-router-dom';

import { useAuth } from '../../../context/auth';
import { showMessage } from '../../../helpers/message';

// Components
import FichaInfracao from '../FichaInfracao';
import CertificadoEntregaComunicacaoEletronica from '../FichaInfracao/components/CertificadoEntregaComunicacaoEletronica';
import BoletoInfracao from '../BoletoInfracao';

// API
import infracoes_api from '../../../api/infracoes_api';
import analiseInfracao_api from '../../../api/analiseInfracao_api';

// Estilo da página de impressão
const pageStyle = `
@page { size: auto; margin: 0mm; } 
@media print { body { -webkit-print-color-adjust: exact; } }
@media print {
  @page { size:A4; margin:0; }
  .relatorio { width:100vw!important; display:flex; flex-direction:column; }
  .noPrint { display:none; }
  .break { page-break-before: always; }
}
`;

export default function ImpressaoFichaInfracaoCompleta() {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const hash = query.get('hash');

    const { setLoading, session } = useAuth();
    const [boletoBase64, setBoletoBase64] = useState(null);
    const [dadosInfracao, setDadosInfracao] = useState(null);
    const [notificacao, setNotificacao] = useState(null);

    const ref = useRef(null);

    const handlePrint = useReactToPrint({
        content: () => ref.current,
        documentTitle: `Auto de Infração_${dadosInfracao?.numeroInfracao}`,
        pageStyle: pageStyle
    });

    async function loadDadosFiscalizacaoInfracao(hash) {
        setLoading(true);
        try {
            const { data } = await infracoes_api.GetItemFiscalizacaoHash(hash);
            setDadosInfracao(data ?? null);

            if (data?.notificacoesEmails?.some(x => x.status === "Confirmado")) {
                setNotificacao(data.notificacoesEmails.find(x => x.status === "Confirmado"));
            } else {
                setNotificacao(null);
            }
        } catch (error) {
            showMessage("Error", error?.message ?? "Erro na operação!", "error", null);
        } finally {
            setLoading(false);
        }
    }

    async function loadBoletoInfracao(infracao) {
        //Mesma regra do botão Boleto da ficha: logado respeita a emissão pelo Gestor; acesso público
        //(sem sessão) respeita a emissão pelo Infrator. Se a etapa não permite, a impressão sai sem o
        //boleto (a API recusaria com 400)
        const permiteBoleto = session != null ? infracao?.permiteBoletoGestor : infracao?.permiteBoletoInfrator;
        if (permiteBoleto === false) {
            setBoletoBase64(null);
            return;
        }

        setLoading(true);
        try {
            const { data } = await analiseInfracao_api.GetSolicitarBoletoPng(infracao.id);
            setBoletoBase64(data || null);
        } catch (error) {
            setBoletoBase64(null);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (hash) {
            loadDadosFiscalizacaoInfracao(hash);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hash]);

    useEffect(() => {
        if (dadosInfracao?.id)
            loadBoletoInfracao(dadosInfracao);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dadosInfracao]);

    if (!dadosInfracao) return <></>;

    return (
        <div className="d-flex flex-column gap-3 p-3" ref={ref}>
            <div className='noPrint'>
                <Button color="danger" onClick={handlePrint} className="mb-3">
                    <FontAwesomeIcon icon={faFilePdf} /> Imprimir
                </Button>
            </div>

            <FichaInfracao impressaoPDFDividaAtiva={{ infracao_id: dadosInfracao.id }} />

            {!!boletoBase64 && <BoletoInfracao base64={boletoBase64} />}

            {notificacao && (
                <CertificadoEntregaComunicacaoEletronica
                    dadosExtracao={notificacao}
                    dadosInfracao={dadosInfracao}
                    impressaoDividaAtivaPDF={true}
                />
            )}
        </div>
    );
}
